import { createContext } from 'react';

/**
 * Context used to coordinate layout properties across form page components.
 * Only used internally.
 */
export const LayoutContext = createContext<{
  /**
   * Height of the bottom nav
   */
  bottomNavHeight?: number;
  /**
   * Callback to set the height of the bottom nav
   */
  setBottomNavHeight?: (height: number) => void;
}>({});
